<template>
  <v-card elevation="0" id="school-card">
    <v-card-text>
      <v-card elevation="0">
        <v-card-title class="text-center">
          <h2>{{ data.school_name }}</h2>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col class="text-center">
              <v-progress-circular
                :value="data.msc"
                color="lightBlue"
                size="200"
                class="msc-rating"
              >
                <img src="@/assets/logo.png" />
                <h4>MSC Competitiveness Score</h4>
                <v-tooltip right max-width="600">
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" v-on="on" text>
                      <v-icon
                        color="primary"
                        class="msc-info"
                      >
                        mdi-help-circle
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>
                                        The MSC competitiveness score is meant
                                        to represent a schools relative
                                        competitiveness from 0-100; the score
                                        takes into account various factors, such
                                        as average GPA/MCAT, a school's
                                        prestige, interview rates, acceptance
                                        rates and more. It is compiled with
                                        thousands of applicants as data points
                                        but is meant to be utilized as a guide
                                        only.
                                    </span>
                </v-tooltip>
                <h3>
                  {{ data.msc }}
                </h3>
              </v-progress-circular>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card elevation="0" class="stats">
        <v-card-title class="text-center blue" color="primary">
          Stats
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col class="text-center">
              <h3>Average MCAT score</h3>
              {{ data.fy_mcat }}
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-center">
              <h3>Average cGPA</h3>
              {{ data.fy_science_gpa }}
            </v-col>
            <v-col class="text-center">
              <h3>Average tGPA</h3>
              {{ data.fy_total_gpa }}
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card elevation="0">
        <v-card-title class="text-center blue">Misc Info</v-card-title>
        <v-card-text :class="color">
          <v-row>
            <v-col cols="12" sm="4" class="text-center">
              <h3>{{ data.type }}</h3>
            </v-col>
            <v-col cols="12" sm="4" class="text-center">
              <h3>Incoming out of State Percentage</h3>
              {{ percentage }}%
            </v-col>
            <v-col cols="12" sm="4" class="text-center">
              <h3>US New Ranking</h3>
              {{ data.us_ranking }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" class="text-center">
              <h3>Interview Format</h3>
              <p>{{ interviewFormat }}</p>
            </v-col>
            <v-col cols="12" sm="6" class="text-center">
              <h3>Total Enrollment</h3>
              <p>{{ enrollment }}</p>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card elevation="0" class="pt-3">
        <v-card-title class="text-center blue">Applicant & Interview Totals</v-card-title>
        <v-card-text :class="color">
          <v-row>
            <v-col cols="12" sm="4" class="text-center">
              <h3>Total Applicants from In State</h3>
              <p>{{ applicationsInState }}</p>
            </v-col>
            <v-col cols="12" sm="4" class="text-center">
              <h3>Number Interviewed from In State</h3>
              <p>{{ interviewedInState }}</p>
            </v-col>
            <v-col cols="12" sm="4" class="text-center">
              <h3>Percent of In State Applicants Interviewed</h3>
              <p>{{ percentInterviewedInState }}%</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="text-center">
              <h3>Total Applicants from Out of State</h3>
              <p>{{ applicationsOutState }}</p>
            </v-col>
            <v-col cols="12" sm="4" class="text-center">
              <h3>Number Interviewed from Out of State</h3>
              <p>{{ interviewedOutState }}</p>
            </v-col>
            <v-col cols="12" sm="4" class="text-center">
              <h3>Percent of Out of State Applicants Interviewed</h3>
              <p>{{ percentInterviewedOutState }}%</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="text-center">
              <h3>Total Applicants International</h3>
              <p>{{ applicationsInternational }}</p>
            </v-col>
            <v-col cols="12" sm="4" class="text-center">
              <h3>Number Interviewed International</h3>
              <p>{{ interviewedInternational }}</p>
            </v-col>
            <v-col cols="12" sm="4" class="text-center">
              <h3>Percent of International Applicants Interviewed</h3>
              <p>{{ percentInterviewedInternational }}%</p>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card elevation="0" class="pt-3">
        <v-card-title class="text-center blue">Matriculant Totals</v-card-title>
        <v-card-text :class="color">
          <v-row>
            <v-col cols="12" sm="6" class="text-right">
              <h3>Total Matriculants from In State</h3>
            </v-col>
            <v-col class="12" sm="6">
              {{ matriculatedInState }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" class="text-right">
              <h3>Total Matriculants from Out of State</h3>
            </v-col>
            <v-col class="12" sm="6">
              {{ matriculatedOutState }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" class="text-right">
              <h3>Total Matriculants from International</h3>
            </v-col>
            <v-col class="12" sm="6">
              {{ matriculatedInternational }}
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-card>
</template>
<script>
import schoolService from '../services/SchoolService'
import axios from 'axios'

export default {
  name: 'School',
  props: ['id'],
  data: () => ( {
    data: {},
    color: 'black',
    percentage: 0,
    interviewFormat: '',
    enrollment: 0,
    applicationsInState: 0,
    applicationsOutState: 0,
    applicationsInternational: 0,
    interviewedInState: 0,
    interviewedOutState: 0,
    interviewedInternational: 0,
    percentInterviewedInState: 0,
    percentInterviewedOutState: 0,
    percentInterviewedInternational: 0,
    matriculatedInState: 0,
    matriculatedOutState: 0,
    matriculatedInternational: 0,
  } ),
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      axios
        .get(`${process.env.VUE_APP_API_BASE}schools/${this.id}`)
        .then(response => {
          this.data = response.data
          this.percentage = (
            response.data.fy_percent_out_state * 100
          ).toFixed(0)
          this.color = schoolService.getAcceptanceColor(
            this.percentage
          )
          this.interviewFormat = response.data.interview_format
          this.enrollment = response.data.enrollment
          this.applicationsInState = response.data.applications_in_state || 0
          this.applicationsOutState = response.data.applications_out_state || 0
          this.applicationsInternational = response.data.applications_international || 0
          this.interviewedInState = response.data.interviewed_in_state || 0
          this.interviewedOutState = response.data.interviewed_out_state || 0
          this.interviewedInternational = response.data.interviewed_international || 0
          this.percentInterviewedInState = response.data.percent_interviewed_in_state || 0
          this.percentInterviewedOutState = response.data.percent_interviewed_out_state || 0
          this.percentInterviewedInternational = response.data.percent_interviewed_international || 0
          this.matriculatedInState = response.data.matriculated_in_state || 0
          this.matriculatedOutState = response.data.matriculated_out_state || 0
          this.matriculatedInternational = response.data.matriculated_international || 0
        })
    },
  },
  watch: {
    id: {
      immediate: true,
      handler () {
        this.getData()
      },
    },
  },
}
</script>
<style lang="scss">
$blue : #183F64;

#school-card {
  .msc-rating {
    .v-progress-circular__info {
      flex-direction : row;
      flex-wrap      : wrap;

      * {
        flex : 0 0 100%;
      }

      img {
        padding-left  : 42%;
        padding-right : 42%;
      }
    }
  }

  .v-card__title.text-center {
    display    : block;
    word-break : break-word;

    &.blue {
      background : #183F64 !important;
      color      : white;
    }
  }

  .v-card__text {
    color : rgba(0, 0, 0, 0.8);
  }

  .stats {
    .row:first-child {
      border-bottom : 1px solid rgba(0, 0, 0, 0.2);
    }
  }

  .msc-info {
    cursor : pointer;
  }
}
</style>
